<template>
  <el-container class="is-vertical container" v-if="games" v-loading.fullscreen.lock="isLoading">
    <div v-if="!error">
      <DataDescription/>
    </div>
    <div class="filters">
      <FiltersContainer :nbVoodooGames="nbVoodooGames"/>
    </div>
    <ListGames v-if="!error" :games="games"/>
    <el-alert
        v-if="error"
        title="Fetching rankings failed"
        type="error"
        :description="error"
        show-icon
        :closable="false"
    />
  </el-container>
</template>

<script>
import { mapGetters } from 'vuex';
import DataDescription from '@/components/DataDescription';
import FiltersContainer from '@/components/Filters/Container';
import ListGames from '@/components/ListGames';

export default {
  name: 'HomeView',
  components: {
    ListGames,
    DataDescription,
    FiltersContainer,
  },
  computed: {
    ...mapGetters({
      games: 'game/filteredGameList',
      nbVoodooGames: 'game/nbVoodooGames',
      isLoading: 'game/isLoading',
      error: 'game/error',
    }),
  },
  beforeCreate() {
    this.$store.dispatch('game/setFilters', {
      storeName: this.$route.params.storeName,
      publisher: this.$route.params.publisher,
    });
  },
};
</script>

<style scoped lang="scss">
@use '@/assets/common.scss' as *;

.container {
  display: flex;
  flex-direction: column;

  &>.filters {
    margin: 10px 0;

    @media #{$media-large-screen} {
      margin: 7px 0 10px;
    }
  }
}
</style>
